"use client";

import DepartmentTable, { DepartmentRow } from "../components/department-table";
import { DepartmentStatusCode } from "../services/department-service";

interface InactiveDepartmentTabProps {
  rows: DepartmentRow[];
  isLoading: boolean;
  onEdit: (row: DepartmentRow) => void;
  onActivate: (row: DepartmentRow) => void;
  onViewDetail: (row: DepartmentRow) => void;
}

const InactiveDepartmentTab: React.FC<InactiveDepartmentTabProps> = ({
  rows,
  isLoading,
  onEdit,
  onActivate,
  onViewDetail,
}) => {
  const inactiveRows = rows.filter((r) => r.statusCode === DepartmentStatusCode.INACTIVE);

  return (
    <DepartmentTable
      rows={inactiveRows}
      isLoading={isLoading}
      startIndex={1}
      onEdit={onEdit}
      onActivate={onActivate}
      onViewDetail={onViewDetail}
    />
  );
};

export default InactiveDepartmentTab;
